(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (function() {
    // Only enable hover on desktop (non-touch devices)
    if (window.matchMedia('(hover: hover)').matches) {
      const allMenuItems = document.querySelectorAll('.header__inline-menu li');
      
      allMenuItems.forEach(function(menuItem) {
        const headerMenu = menuItem.querySelector('header-menu');
        const details = menuItem.querySelector('details.mega-menu');
        const summary = menuItem.querySelector('summary');
        const content = menuItem.querySelector('.mega-menu__content');
        
        // Only process items with mega menus
        if (!headerMenu || !details || !summary || !content) return;
        
        let hoverTimeout;
        let isHovering = false;
        
        // Open menu on hover
        function openMenu() {
          clearTimeout(hoverTimeout);
          isHovering = true;
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
            // Trigger the HeaderMenu onToggle if it exists
            if (headerMenu && typeof headerMenu.onToggle === 'function') {
              headerMenu.onToggle();
            }
          }
        }
        
        // Close menu with delay
        function closeMenu() {
          clearTimeout(hoverTimeout);
          isHovering = false;
          hoverTimeout = setTimeout(function() {
            if (!isHovering && details.hasAttribute('open')) {
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
            }
          }, 150); // Small delay to allow moving between menu item and content
        }
        
        // Mouse enter on menu item
        menuItem.addEventListener('mouseenter', openMenu);
        
        // Mouse leave from menu item
        menuItem.addEventListener('mouseleave', closeMenu);
        
        // Keep open when hovering over content
        content.addEventListener('mouseenter', function() {
          clearTimeout(hoverTimeout);
          isHovering = true;
        });
        
        content.addEventListener('mouseleave', closeMenu);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
